export enum CourseStatus {
    DRAFT,
	ACTIVE,
	DELETED,
	ALL
}